// /*********************** Custom JS for Boost AI Search & Discovery  ************************/

// Fix scroll when closing the ISW
document.addEventListener("click", function(event) {
    if (event.target.closest('button[data-header-search-close]')
       || typeof(event.target.attributes['data-header-search-close']) !== 'undefined') {
        document.querySelector('body').classList.remove('boost-sd__search-opening');
    }
});

const selectSwatch = (swatch) => {
  const activeClass = 'boost-sd__product-swatch-option--selected';
  const activeLabel = 'boost-sd__radio-label--selected';
  if (!swatch) return;

  const activeSwatch = swatch.parentElement.getElementsByClassName('boost-sd__product-swatch-option--selected')[0];
  if (activeSwatch) {
    activeSwatch.classList.remove(activeClass);
    activeSwatch.querySelector('.boost-sd__radio-label').classList.remove(activeLabel)
  }

  swatch.classList.add(activeClass);
  swatch.querySelector('.boost-sd__radio-label').classList.add(activeLabel);
};

const stripHtml = (html) =>{
  let tmp = document.createElement("DIV");
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText || "";
}

const customize = {
  updateProductItem: (componentRegistry) => {
    componentRegistry.useComponentPlugin('ProductItem', {
      name: 'Modify Product Item Element',
      enabled: true,
      apply: () => ({
        afterRender(e) {
          /* stuff we need: */
          const productItem = e.getRootElm(); /* dom object: */
          const { product } = e.getParams().props; /* product JSON: */

          console.log(product)

          /* for a metafield to show up here, it needs to be added as "Display" under Boost > Tool > Metafields: */
          const { metafields } = product;

          /* looking for product.metafields.custom.headline: */
          const subheading = metafields.find(((mf) => mf.namespace === 'custom' && mf.key === 'headline'));

          /* this runs every time we load more so only do these once: */
          if (productItem.classList.contains('is-loaded')) return;
          productItem.classList.add('is-loaded');

          // selectSwatch(productItem.querySelector('.boost-sd__product-swatch-option'));

          productItem.addEventListener('click', (e) => {
            /* if they've clicked a swatch: */
            const swatch = e.target.closest('.boost-sd__product-swatch-option');
            if (!swatch) return;

            selectSwatch(swatch);

            /* get new color: */
            const value = swatch.getElementsByClassName('boost-sd__radio-input')[0].value;

            /* get product variant: */
            const variant = product.variants.find((variant => variant.title.indexOf(value) > -1));
            if (!variant) return;

            /* update URL: */
            const url = '/products/' + product.handle + '?variant=' + variant.id;
            Array.from(productItem.getElementsByTagName('a')).map((a) => a.href = url);

            /* update default image: */
            const img = productItem.getElementsByClassName('boost-sd__product-image-img--main')[0];
            if (img && variant.image) {
              img.src = variant.image;
              img.srcset = '';
            }
          });

          /* updating product tile subheading: */
          const title = productItem.getElementsByClassName('boost-sd__product-title')[0];
          let summary = productItem.getElementsByClassName('boost-sd__product-summary')[0];
          let reviews = productItem.getElementsByClassName('boost-sd__product-reviews')[0];

          title.innerHTML = stripHtml(title.textContent);

          if (!summary && title) {
            summary = document.createElement('div');
            summary.classList = 'boost-sd__product-summary';
            summary.textContent = subheading ? subheading.value : ''; /* set to empty string if no subheading */
            title.after(summary);
          }

          if (!reviews && title) {
            const productUrl = '/products/' + product.handle;

            reviews = document.createElement('div');
            reviews.className = 'custom-inline-review-wrapper';
            reviews.innerHTML = '<div data-bv-show="inline_rating" data-bv-product-id="' + product.id + '" data-bv-redirect-url="' + productUrl + '" data-bv-seo="false"> </div>';
            title.before(reviews);
          }

          /* Product Badges */
          if (productItem.querySelector('.boost-sd__product-label--customLabelByTag')) {
            const badgeEle = productItem.querySelector('.boost-sd__product-label--customLabelByTag .boost-sd__product-label-text');
            let badgeLabel = badgeEle.textContent;

            let productTagString = product.tags.join(',').toLowerCase();

            if (productTagString.includes('new design')) {
              badgeLabel = 'New Design';
            } else if (productTagString.includes('new color')) {
              badgeLabel = 'New Color';
            } else if (productTagString.includes('new')) {
              badgeLabel = 'New';
            } else {
              product.tags.forEach(tag => {
                const pfsBadge = (tag.includes('pfs:label-')) ? tag.split('pfs:label-')[1] : '';
                if (pfsBadge) {
                  badgeLabel = pfsBadge;
                  return false;
                }
              });
            }

            badgeEle.textContent = badgeLabel;
          }
        }
      }),
    });
  }
};


window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([customize.updateProductItem]);
